import React from "react";
import "./style.css";

export default function WebDropdown({
  options,
  className,
  parentClassName,
  onChange,
  disable,
  selected,
}) {
  return (
    <div className={parentClassName}>
      <select
        className={
          className ? className : "my-1 border px-3 py-2 w-full rounded"
        }
        onChange={onChange}
      >
        {options?.map((item, index) => {
          return (
            <option
              key={index}
              value={item.value}
              selected={selected === item.value}
              disabled={disable}
              data-level={item.level || 0}
              style={{
                paddingLeft: item.level ? `${(item.level * 12) + 8}px` : '8px',
                fontWeight: item.level === 0 ? '600' : item.level === 1 ? '500' : '400',
                color: item.level === 0 ? '#1f2937' : item.level === 1 ? '#374151' : '#6b7280'
              }}
            >
              {item.name || item.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
